import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyDuXiorcd3RxI6UX3PtFibZ80HOBVvIK3I",
//   authDomain: "empoweredman-40f5b.firebaseapp.com",
//   projectId: "empoweredman-40f5b",
//   storageBucket: "empoweredman-40f5b.firebasestorage.app",
//   messagingSenderId: "5996932463",
//   appId: "1:5996932463:web:c12089496cee7e016ecc9a",
//   measurementId: "G-B0VXLMFPW4",
// };

// const app = initializeApp(firebaseConfig);
// export const db = getFirestore(app);
// // export const messaging = getMessaging(app);

// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
// export const messaging = getMessaging(app);
